import types from '../types'
import 'firebase/compat/database'

export const getModules = (database) => async (dispatch) => {
  const dbRef = database.ref(`modules`)

  await dbRef.on(
      'value',
      (snapshot) => {
        const val = snapshot.val()
        const modules = val
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            modules,
          },
        })
      },
      (errorObject) => console.log(errorObject),
  )
}
